import React, { useRef } from "react";
import { connect } from "react-redux";
import SvgVirtualMeter from "../../_svg/VirtualMeter";
import { withTranslation } from 'react-i18next';
import indicatorActions from "../../redux/indicator/indicator.action";

const App = (props) => {
  const { t, indicator, dispatch } = props
  const ref = useRef();
  const content = {
    title: t('logiciels.cc.vm'),
    description: t('logiciels.cc.vm.description')
  }

  return (
              <div className={"svg-container"} id="svg-vm" itemScope itemType="https://schema.org/WepPage">
                  <div>
                    <SvgVirtualMeter fill={"#31c6b3"}/>
                <h3 itemProp="alternativeHeadline">{content.title}</h3>
                    <span itemProp="description">
                      {content.description}
                    </span>
                  </div>
              </div>
  );
};

function mapStateToProps(state) {
  const { indicator } = state;

  return {
    indicator,
  };
}

const connectedCrystalcloud = connect(mapStateToProps)(App);
const tr = withTranslation()(connectedCrystalcloud);
export default tr;
